<template>
    <div class="container">
        <nav class="nav-container">
            <router-link class="link_container" :to="'/dialer/register'" active-class="link-active">
                <img class="small_img" src="../assets/stage1-red.png" alt="pic1" />
                <span>{{ $t("register") }}</span>
            </router-link>
            <button :class="
              title === 'upload' ? 'link_container link-active' : 'link_container'
            " :disabled="title === 'upload'" @click="changeStep('upload')">
            <img class="small_img" src="../assets/stage2-red.png" alt="" />
            <span>{{ $t("upload") }}</span>
          </button>
            <button :class="
              title === 'payment' ? 'link_container link-active' : 'link_container'
            " :disabled="title === 'payment'" @click="changeStep('payment')">
            <img class="small_img" src="../assets/stage3-red.png" alt="" />
            <span>{{ $t("payment") }}</span>
          </button>
        </nav>
    
        <h4 class="round_red_box white_title">{{ $t(title) }}</h4>
        <router-view @registerSubmit="submitRegister" :data="formData" @registerFormChange="setDataApprovedFalse('registerApproved')" @uploadSubmit="submitUpload" @uploadFormChange="setDataApprovedFalse('fileApproved')" @submitPayment="setPaymentInfo" @switchPayment="setPaymentInfoToNull"></router-view>
        <button v-if="formData.comaxCardToken && title === 'payment'" @click="submitCampaign" class="custom_form_next_btn">
          {{ $t("submit campaign") }}
        </button>
    </div>
</template>

<script>
import validate from "../utils/Validate";
import RegisterService from "../services/registerService";
export default {
    name: "DialerForm",
    data: () => ({
        titles: {
            "/dialer/register": "register",
            "/dialer/upload": "upload",
            "/dialer/payment": "payment",
        },
        title: "",
        validateFunctions: validate,
        registerFormFields: ["fname", "lname", "email", "phone"],
        uploadFormFields: [
            "csvFile",
            "audioFile",
            "csvArray",
            "typeOfList",
            "date",
            "time",
        ],
        formData: {
            fname: "",
            lname: "",
            email: "",
            phone: "",
            date: new Date(),
            time: "",
            registerApproved: false,
            csvFile: null,
            audioFile: null,
            csvArray: null,
            fileApproved: false,
            typeOfList: "file",
            recivefeedback: false,
            comax: {},
        },
        registerService: new RegisterService(),
        resendEmailStatus: false,
        sendCampaign: false,
    }),
    mounted() {
        this.title = this.titles[this.$route.path];
        if (!this.formData.accountId) {
            this.$router.push({ path: "/dialer/" });
        }
    },
    watch: {
        $route(to) {
            this.title = this.titles[to.fullPath];
        },
    },
    methods: {
        async submitRegister(data) {
            if (data.registerApproved) {
                this.$router.push({ path: "/dialer/upload" });
                return;
            }
            if (!validate.isObjectsAreEqual(data, this.formData, this.registerFormFields)) {
                this.formData.accountId = (
                    await this.registerService.register(data)
                ).data.id;
                if (!this.formData.accountId) {
                    return;
                }
                this.saveData(data);
            }
            const result = await this.$swal({
                title: this.$t("Send email for confirmation"),
                input: "text",
                inputAttributes: {
                    autocapitalize: "off",
                    placeHolder: this.$t("code"),
                },
                confirmButtonText: this.$t("submit"),
                showLoaderOnConfirm: true,
                footer: `<span id="send_email_again" class="link_span">${this.$t(
          "send_email_again"
        )}</span>`,
                preConfirm: async (code) => {
                    if (!code) {
                        this.$swal.showValidationMessage(this.$t("there is no code"));
                        return;
                    }
                    try {
                        const verify = (
                            await this.registerService.verifyRegister({
                                id: this.formData.accountId,
                                code,
                            })
                        ).data.verify;
                        if (verify) {
                            return code;
                        } else {
                            this.$swal.showValidationMessage(this.$t("wrong code"));
                        }
                    } catch(e) {
                        this.$swal.showValidationMessage(this.$t("there is a problem please try again"));
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
                didOpen: () => {
                    const el = document.getElementById("send_email_again");
                    el.addEventListener("click", this.resendEmail);
                },
                willClose: () => {
                    const el = document.getElementById("send_email_again");
                    el.removeEventListener("click", this.resendEmail);
                },
            });
            if (result.isConfirmed) {
                data.registerApproved = true;
                this.saveData(data);
                this.$router.push({ path: "/dialer/upload" });
            }
        },
        submitUpload(data) {
            data.fileApproved = true;
            this.saveData(data);
            this.$router.push({ path: "/dialer/payment" });
        },
        setPaymentInfo(data) {
            if (data !== null) {
                this.formData.comaxCardToken = data.data.token;
                this.submitCampaign();
            }
        },
        setPaymentInfoToNull() {
            if (this.formData.comaxCardToken) {
                this.formData.comaxCardToken = null;
            }
        },
        didOpen: async () => {
          this.$swal.showLoading();
          this.sendCampaign = false;
          const create = await this.registerService.createCampaign(
            this.formData
          );
          if(create.stauts === "422"){
            this.title = "upload";
            return;
          }
        //   value = create;
          this.$swal.getConfirmButton().style.display = "block";
          this.$swal.update({ 
            title: this.$t("your request is done!") ,
            text: "" ,
            confirmButtonText: this.$t("go to finish page"),
            showConfirmButton: true,
            })	
          this.$swal.hideLoading();
        },

        async submitCampaign() {
            let value = "";
            this.sendCampaign = true;
            if (!this.sendCampaign) {
                return;
            }
            const result = await this.$swal({
                title: this.$t("your request is send"),
                text: this.$t("your requset can take time"),
                confirmButtonText: this.$t("go to finish page"),
                showConfirmButton: false,
                timerProgressBar: true,
                allowOutsideClick: !this.sendCampaign,
                preConfirm: async () => {
                    return value;
                },
                didOpen: async () => {
                    this.$swal.showLoading();
                    this.sendCampaign = false;
                    const create = await this.registerService.createCampaign(this.formData);
                    if(create.status === "422") {
                        this.$router.push({ path: "/dialer/upload" });
                        return;
                    }
                    value = create;
                    this.$swal.update({ 
                        title: this.$t("your request is done!"), 
                        text: "",
                        confirmButtonText: this.$t("go to finish page"),
                        showConfirmButton: true,
                    })	
                    this.$swal.getConfirmButton().style.display = "block";
                    // this.$swal.getTitle().textContent =  this.$t("your request is done!")
                    //   document.getElementById("swal2-content").innerText = "התהליך הסתיים בהצלחה!"
                    this.$swal.hideLoading();
                },
            });
            // this.sendCampaign = false;
            if (
                result &&
                result.value &&
                result.value.data &&
                (result.value.data.message === "the_campaign_created" ||
                    result.value.data.message === "the_campaign_already_created")
            ) {
                this.formData = {
                    fname: "",
                    lname: "",
                    email: "",
                    phone: "",
                    date: new Date(),
                    time: "",
                    registerApproved: false,
                    csvFile: null,
                    audioFile: null,
                    csvArray: null,
                    fileApproved: false,
                    typeOfList: "file",
                    recivefeedback: false,
                    comax: {},
                };
                this.$router.push({ path: "/thankPage" });
            }
        },

        setDataApprovedFalse(str) {
            this.formData[str] = false;
        },
        saveData(data) {
            Object.assign(this.formData, data);
        },
        async resendEmail(e) {
            if (this.resendEmailStatus) {
                return;
            }
            this.resendEmailStatus = true;
            e.target.innerText = this.$t("we_send_the_code");
            e.target.classList.toggle("link_span--disable");
            await this.registerService.resendCodeToEmail({
                id: this.formData.accountId,
                email: this.formData.email,
            });
            setTimeout(() => {
                this.resendEmailStatus = false;
                e.target.innerText = this.$t("send_email_again");
                e.target.classList.toggle("link_span--disable");
            }, 3000);
        },
        changeStep(to) {
            switch (this.title) {
                case "register":
                    {
                        const isRegisterValid =
                            this.validateFunctions.validObject(
                                this.formData,
                                this.registerFormFields
                            ) && this.formData.registerApproved;
                        if (
                            to === "payment" &&
                            isRegisterValid &&
                            this.formData.fileApproved
                        ) {
                            this.$router.push({ path: "/dialer/payment" });
                            return;
                        }
                        if (to === "upload" && isRegisterValid) {
                            this.$router.push({ path: "/dialer/upload" });
                            return;
                        }

                        this.$swal({
                            title: this.$t("cant go step forward"),
                            icon: "warning",
                        });
                    }
                    break;
                case "upload":
                    {
                        const fields = this.uploadFormFields.filter((current) => {
                            if (current === "csvArray") {
                                return this.formData.typeOfList === "array";
                            }
                            if (current === "csvFile") {
                                return this.formData.typeOfList === "file";
                            }
                            return true;
                        });
                        const isUploadValid =
                            this.validateFunctions.validObject(this.formData, fields) &&
                            this.formData.fileApproved;
                        if (to === "payment" && isUploadValid) {
                            this.$router.push({ path: "/dialer/payment" });
                            return;
                        }
                        this.$swal({
                            title: this.$t("cant go step forward"),
                            icon: "warning",
                        });
                    }
                    break;
                case "payment":
                    this.$router.push({ path: "/dialer/upload" });
                    break;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>

